export const EMAIL_COMPOSER_ROW_LABEL_WIDTH = '76px';
